var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHoverCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#DEDEDF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.166 18.3332C18.7058 18.3332 18.3327 18.7063 18.3327 19.1665V26.6665C18.3327 27.1267 18.7058 27.4998 19.166 27.4998H26.666C27.1263 27.4998 27.4993 27.1267 27.4993 26.6665V19.1665C27.4993 18.7063 27.1263 18.3332 26.666 18.3332H19.166ZM16.666 19.1665C16.666 17.7858 17.7853 16.6665 19.166 16.6665H26.666C28.0467 16.6665 29.166 17.7858 29.166 19.1665V26.6665C29.166 28.0472 28.0467 29.1665 26.666 29.1665H19.166C17.7853 29.1665 16.666 28.0472 16.666 26.6665V19.1665Z",
    fill: "#68666C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.334 12.5002C13.113 12.5002 12.901 12.588 12.7447 12.7442C12.5884 12.9005 12.5007 13.1125 12.5007 13.3335V20.8335C12.5007 21.0545 12.5884 21.2665 12.7447 21.4228C12.901 21.579 13.113 21.6668 13.334 21.6668H14.1673C14.6276 21.6668 15.0007 22.0399 15.0007 22.5002C15.0007 22.9604 14.6276 23.3335 14.1673 23.3335H13.334C12.6709 23.3335 12.0351 23.0701 11.5662 22.6013C11.0974 22.1324 10.834 21.4965 10.834 20.8335V13.3335C10.834 12.6705 11.0974 12.0346 11.5662 11.5657C12.0351 11.0969 12.6709 10.8335 13.334 10.8335H20.834C21.497 10.8335 22.1329 11.0969 22.6018 11.5657C23.0706 12.0346 23.334 12.6705 23.334 13.3335V14.1668C23.334 14.6271 22.9609 15.0002 22.5007 15.0002C22.0404 15.0002 21.6673 14.6271 21.6673 14.1668V13.3335C21.6673 13.1125 21.5795 12.9005 21.4232 12.7442C21.267 12.588 21.055 12.5002 20.834 12.5002H13.334Z",
    fill: "#68666C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHoverCopy);
export default __webpack_public_path__ + "static/media/icon-hover-copy.bff1463e0efb80ce147b2bd6992ddc2d.svg";
export { ForwardRef as ReactComponent };